import { useAtomValue } from 'jotai';

import { SettingsDrawerControl } from '../../session';
import { PUSH_DRAWER_ARIA_CONTROLS_ID } from '../constants';
import { ProviderDrawerState, drawerStateAtom } from '../state';
import { ProviderSettingsDrawerControlMenuItem } from './ProviderSettingsDrawerControls';
import { useToggleProviderDrawerStateCallback } from './useToggleProviderDrawerStateCallback';

export function ProviderSettingsDrawerControlMenuItemWrapper() {
  const { isSettingsDrawerOpen, toggleDrawerState } = useProviderDrawerControls();
  return (
    <ProviderSettingsDrawerControlMenuItem isSettingsDrawerOpen={isSettingsDrawerOpen} onClick={toggleDrawerState} />
  );
}

export function ProviderSettingsDrawerButton() {
  const { isSettingsDrawerOpen, toggleDrawerState } = useProviderDrawerControls();
  return (
    <SettingsDrawerControl
      forDrawerStates={ProviderDrawerState.SETTINGS}
      isSettingsDrawerOpen={isSettingsDrawerOpen}
      onClick={toggleDrawerState}
      drawerId={PUSH_DRAWER_ARIA_CONTROLS_ID}
    />
  );
}

function useProviderDrawerControls() {
  const drawerState = useAtomValue(drawerStateAtom);
  const isSettingsDrawerOpen = drawerState === ProviderDrawerState.SETTINGS;

  const toggleDrawerState = useToggleProviderDrawerStateCallback(ProviderDrawerState.SETTINGS);

  return {
    isSettingsDrawerOpen,
    toggleDrawerState,
  };
}
